interface DrawerStackRegistration {
  opened: boolean;
  onClose: () => void;
}

/**
 * The props `Drawer.Root` accepts from a `useDrawersStack` registration.
 *
 * Only `Drawer` reads the registration's `stackId`. `Drawer.Root` passes unknown props on to the
 * DOM, where React warns about `stackId`.
 */
export function toDrawerRootProps({ opened, onClose }: DrawerStackRegistration) {
  return { opened, onClose };
}
